import React, { useState } from 'react';
import socket from '../../socket';
import Button from '../ui/Button';

// Einfache, einfarbige Linien-Icons (kein Emoji) - erben ueber currentColor
// die Textfarbe des umgebenden Buttons.
function PlusIcon() {
    return (
        <svg className="team-join-chip-icon" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    );
}

function KeyIcon() {
    return (
        <svg className="team-join-chip-icon" width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="5" cy="5" r="3" stroke="currentColor" strokeWidth="1.4" />
            <path d="M7.2 7.2L14 14M10.5 10.5v2M12.5 12.5v1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
    );
}

// Kompaktes Widget: zwei Buttons ("Team erstellen" / "beitreten"), die jeweils
// ein einzeiliges Eingabefeld aufklappen. Mittelweg zwischen einer grossen
// Tab-Karte und zwei nackten Buttons - leichte Karte mit Titel, aber ohne
// separate Tabs/volle Formulare.
function TeamJoinPanel({ playerId }) {
    const [open, setOpen] = useState(null); // null | 'create' | 'join'
    const [teamName, setTeamName] = useState('');
    const [joinCode, setJoinCode] = useState('');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    function reset() {
        setOpen(null);
        setTeamName('');
        setJoinCode('');
        setError(null);
        setBusy(false);
    }

    function handleCreate() {
        const name = teamName.trim();
        if (!name) {
            setError('Bitte Teamnamen eingeben.');
            return;
        }
        setBusy(true);
        setError(null);
        socket.emit('createTeamByPlayer', { playerId, name }, (resp) => {
            if (!resp?.ok) {
                setBusy(false);
                setError(resp?.error || 'Fehler beim Erstellen.');
                return;
            }
            reset();
        });
    }

    function handleJoin() {
        const code = joinCode.trim();
        if (!/^\d{4}$/.test(code)) {
            setError('4-stelliger Code.');
            return;
        }
        setBusy(true);
        setError(null);
        socket.emit('joinTeamByCode', { playerId, code }, (resp) => {
            if (!resp?.ok) {
                setBusy(false);
                setError(resp?.error || 'Fehler beim Beitreten.');
                return;
            }
            reset();
        });
    }

    return (
        <div className="team-join-panel">
            <div className="team-join-panel-title">Noch in keinem Team?</div>

            {open === null && (
                <div className="team-join-panel-chips">
                    <button type="button" className="team-join-chip" onClick={() => setOpen('create')}>
                        <PlusIcon /> Team erstellen
                    </button>
                    <button type="button" className="team-join-chip" onClick={() => setOpen('join')}>
                        <KeyIcon /> Team beitreten
                    </button>
                </div>
            )}

            {open === 'create' && (
                <div className="team-join-panel-inline">
                    <input
                        className="team-join-panel-input"
                        type="text"
                        autoFocus
                        placeholder="Teamname"
                        value={teamName}
                        onChange={(e) => setTeamName(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
                    />
                    <Button variant="primary" size="sm" onClick={handleCreate} disabled={busy}>OK</Button>
                    <button type="button" className="team-join-panel-cancel" onClick={reset} aria-label="Abbrechen">×</button>
                </div>
            )}

            {open === 'join' && (
                <div className="team-join-panel-inline">
                    <input
                        className="team-join-panel-input team-join-panel-input-code"
                        type="text"
                        autoFocus
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={4}
                        placeholder="1234"
                        value={joinCode}
                        onChange={(e) => setJoinCode(e.target.value.replace(/\D/g, '').slice(0, 4))}
                        onKeyDown={(e) => e.key === 'Enter' && handleJoin()}
                    />
                    <Button variant="primary" size="sm" onClick={handleJoin} disabled={busy}>OK</Button>
                    <button type="button" className="team-join-panel-cancel" onClick={reset} aria-label="Abbrechen">×</button>
                </div>
            )}

            {error && <p className="team-join-panel-error">{error}</p>}
        </div>
    );
}

export default TeamJoinPanel;
